import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import AnchorButton from '../components/common/AnchorButton';

export default ({ propSelectors, actions, defaultProps = {} }: $TSFixMe) => {
    const ConnectedButton = connect(createStructuredSelector(propSelectors), actions)(AnchorButton);

    (ConnectedButton as $TSFixMe).defaultProps = defaultProps;

    return ConnectedButton;
};
